/**
 * Shared types for the experimentation framework.
 *
 * The catalog itself (variants + weights + active flag) lives backend-only in
 * `packages/backend/src/app/experiment/experiment.catalog.ts`. The frontend
 * only receives the resolved variant via `GET /app/experiments/me`.
 */

import { Type, type Static } from '@sinclair/typebox';

export const EXPERIMENT_KEYS = {
  SIGNUP_CB_V1: 'signup_cb_v1',
} as const;

export type ExperimentKey = (typeof EXPERIMENT_KEYS)[keyof typeof EXPERIMENT_KEYS];

export const SIGNUP_CB_VARIANTS = {
  NO_CB: 'no_cb',
  CB_UPFRONT: 'cb_upfront',
  CB_AFTER_ONBOARDING: 'cb_after_onboarding',
} as const;

export type SignupCbVariant = (typeof SIGNUP_CB_VARIANTS)[keyof typeof SIGNUP_CB_VARIANTS];

/**
 * Map of `experiment_key -> variant` returned by `GET /app/experiments/me`.
 * Modelled as an open string-to-string record (rather than a closed object)
 * so the catalog can grow without a coordinated front/back release.
 */
export const ExperimentAssignmentMapSchema = Type.Record(Type.String(), Type.String(), {
  description: 'Map of active experiment assignments for the current professional',
});

export type ExperimentAssignmentMap = Partial<Record<ExperimentKey, string>> &
  Static<typeof ExperimentAssignmentMapSchema>;
